// removed by extract-text-webpack-plugin
module.exports = {"vpDynamicCollectorsContainer":"vpDynamicCollectorsContainer___3Yxcg","vpCollectorWrapper":"vpCollectorWrapper___1oIF7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/DynamicCollectors.module.less
// module id = 3848
// module chunks = 33